import { createTheme } from "@mui/material";
import { join } from 'lodash-es';
import { Colors } from '@sweatpals/react-ui-kit';

declare module '@mui/material/styles' {
	interface PaletteColor {
		brand?: string;
		heading?: string;
		shadow?: string;
		backgroundLight?: string;
		backgroundHover?: string;
	}
	interface SimplePaletteColorOptions {
		brand?: string;
		heading?: string;
		shadow?: string;
		backgroundLight?: string;
		backgroundHover?: string;
	}
}

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		xs: true;
		s: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		xxl: true;
	}
}

export const BACKGROUND_COLOR_LIST: string[] = [
	Colors['FF6000'],
];

export const appZoom = 1;

export const theme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			s: 450,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
			xxl: 1920
		},
	},
	palette: {
		primary: {
			main: Colors['2B2D2F'],
			light: Colors.white,
			dark: Colors['131415'],
			shadow: Colors.black,
			brand: Colors['FA8334'],
			heading: Colors['0B162B'],
			backgroundLight: Colors['FABE2C'],
			backgroundHover: 'rgba(246, 241, 237, 0.4)'
		},
		secondary: {
			main: Colors['868078'],
			light: Colors['F7F3F0'],
			brand: Colors['EB6D19'],
			heading: Colors['8F6F57'],
			backgroundLight: Colors['BAA697'],
		},
		background: {
			default: Colors['292827'],
			paper: Colors['F7F3F0'],
		}
	},
	typography: {
		fontFamily: join(['Nunito', 'Reenie Beanie', 'Caveat', 'Montserrat', 'Avenir', 'sans-serif'], ',')
	},
	components: {
		MuiLink: {
			styleOverrides: {
				root: {
					cursor: 'pointer',
					textDecoration: 'none'
				}
			}
		},
	}
});
